export const GET_LECTURE_LIST_QUERY = (status: number, keyword: string, page: number): string => `
    query {
        getLectures(title: "${keyword}", status: ${status}, page: ${page}) {
            items {
                seq
                title
                expiredDate
                price
                count
                capacity
                isActivated
            }
            currentPage
            totalPage
            totalItems
        }
    }`;

export const GET_LECTURE_LISTENER_QUERY = (lectureSeq: number, keyword: string, statusTypes: number[], page: number): string => `
    query {
        getListeners(lectureSeq: ${lectureSeq}, name: "${keyword}", status: [${statusTypes}], page: ${page}) {
            items {
                seq
                applicationDate
                headCount
                name
                email
                phone
                status
            }
            currentPage
            totalPage
            totalItems
        }
    }`;

export const GET_LECTURE_DETAIL_QUERY = (seq: number): string => `
    query {
        getLecture(seq: ${seq}) {
            seq
            title
            content
            expiredDate
            price
            capacity
            thumbnailFileName
            refundRules {
                leftDays
                rate
            }
        }
    }`;